






import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BaseContentCategory',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  data(): any {
    return {
      items: [],
    };
  },
  mounted() {
    const item = {
      title: this.title,
      items: this.items,
    };
    this.$parent.items.push(item);
  },
  methods: {},
});
